export const switchButton = {
    namespaced: true,
    state: {
        switch: true
    },
    getters: {
        getSwitch(state) {
            return state.switch
        }
    },
    mutations: {
        SET_SWITCH(state, payload){
            state.switch = payload
        }
    },
    actions: {
        setSwitch({ commit }, payload) {
            commit('SET_SWITCH', payload)
        }
    }
}